// extracted by mini-css-extract-plugin
export default {"form":"CollaboratorEdit_form__gyPNJ"};